import type { CssConstants } from "~/styles/exports/constants"
import values from "~/styles/tokens/variables.json"

export const grid: CssConstants = {
  values,
  toCss: () =>
    Object.entries(values)
      .map(([name, value]) => `$${name}: ${value};`)
      .join("\n"),
}
